import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadConfig } from "./lib/config";
import "./styles.css";

loadConfig()
  .then(() => createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>))
  .catch((e) => {
    document.getElementById("root")!.textContent = `設定を読み込めませんでした: ${String(e)}`;
  });
